/* eslint-disable @typescript-eslint/ban-ts-ignore */
import React from 'react'
import styles from '@bt-react/styles'
import { Row as ReactstrapRow, RowProps as ReactstrapRowProps } from 'reactstrap'

interface RowProps extends Partial<ReactstrapRowProps> {
  children?: any
}

export default class Row extends React.Component<RowProps> {

  render () {

    return (
      // @ts-ignore
      <ReactstrapRow {...this.props} cssModule={styles} >
        {this.props.children}
      </ReactstrapRow>
    )

  }

}
